import React from "react";
import "./MainScreenDividingLine.css";
import rect6430 from "../../img/rectangle-6430-zircon.svg";
import rectOG from "../../img/rectangle-6430@1x.svg"

const MainScreenDividingLine = () => {

  return (
    <div className="main-screen-dividing-line">
      <div className="overlap-group-42 border-1px-athens-gray-3">
        <img className="rectangle-6430" src={rectOG} />
        <img className="rect-right" src={rectOG} />
        <img className="rect-left" src={rectOG} />
        <img className="middle-1" src={rect6430} />
        <img className="middle-2" src={rect6430} />
        <img className="middle-3" src={rect6430} />
        <img className="middle-4" src={rect6430} />
        <img className="middle-5" src={rect6430} />
        <img className="middle-6" src={rect6430} />
        <img className="middle-7" src={rect6430} />
        <img className="middle-8" src={rect6430} />
      </div>
    </div>
  );
}

export default MainScreenDividingLine;
